(() => {
    if (window.dmProductCardCartHandlerInstalled) return;
    window.dmProductCardCartHandlerInstalled = true;

    const setStatus = (button, message, isError = false) => {
      const popup = button.closest('.product-card__variant-popup');
      if (!popup) return;

      let status = popup.querySelector('.product-card__cart-status');
      if (!status) {
        status = document.createElement('div');
        status.className = 'product-card__cart-status';
        popup.append(status);
      }
      status.setAttribute('role', isError ? 'alert' : 'status');
      status.setAttribute('aria-live', isError ? 'assertive' : 'polite');
      status.textContent = message;
    };

    const recoverSuccessfulAdd = (button) => {
      const language = document.documentElement.lang || '';
      const message = language.toLowerCase().startsWith('tr')
        ? 'Ürün sepete eklendi ancak sepet güncellenemedi. Tekrar eklemeden önce sepetinizi kontrol edin.'
        : 'Added to cart, but the cart could not refresh. Check your cart before trying again.';
      setStatus(button, message);
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      const drawer = document.querySelector('cart-drawer');
      if (typeof drawer?.show === 'function') {
        try {
          drawer.show();
        } catch {}
      }
    };

    document.addEventListener('click', async (event) => {
      const button = event.target.closest?.('.product-card__variant-button[data-variant-id]');
      if (!button) return;

      event.preventDefault();
      event.stopPropagation();
      if (button.disabled || button.getAttribute('aria-busy') === 'true') return;

      const variantId = button.dataset.variantId;
      if (!variantId) return;

      button.setAttribute('aria-busy', 'true');
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

      let addedToCart = false;
      try {
        const sections = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
          bubbles: true,
          detail: { sections }
        }));

        const formData = new FormData();
        formData.set('id', variantId);
        formData.set('quantity', '1');
        formData.set('sections', sections.join(','));
        formData.set('sections_url', `${Shopify.routes.root}variants/${variantId}`);

        const addResponse = await fetch(`${Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          body: formData,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        addedToCart = addResponse.ok;
        const added = await addResponse.json();

        if (!addResponse.ok) {
          const message = added.description || added.message || 'Could not add this item to the cart.';
          setStatus(button, message, true);
          button.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { error: message } }));
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          return;
        }
        const cartResponse = await fetch(`${Shopify.routes.root}cart.js`);
        if (!cartResponse.ok) {
          recoverSuccessfulAdd(button);
          return;
        }
        const cart = await cartResponse.json();
        const bundledSections = added.sections || {};
        const missingDrawerSection = (
          sections.length === 0 || sections.some((section) => typeof bundledSections[section] !== 'string')
        );
        if (missingDrawerSection) {
          recoverSuccessfulAdd(button);
          return;
        }
        cart.sections = bundledSections;
        const items = Object.prototype.hasOwnProperty.call(added, 'items') ? added.items : [added];
        const detail = { items, cart, onSuccessDo: 'force_open_drawer' };
        button.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: { baseEvent: 'variant:add', onSuccessDo: 'force_open_drawer', cart }
        }));

        setStatus(button, window.themeVariables.strings.addedToCart || 'Added to cart');
        button.closest('.product-card__variant-popup')?.classList.remove('active');
      } catch (error) {
        if (addedToCart) {
          recoverSuccessfulAdd(button);
          return;
        }
        const message = error.message || 'Could not add this item to the cart.';
        setStatus(button, message, true);
        button.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { error: message } }));
      } finally {
        button.removeAttribute('aria-busy');
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
      }
    }, true);
  })();
